export default __webpack_public_path__ + "static/media/star-dark.153a85dc.svg";